import React, {Component} from "react"

import {
  ApiForm,
  FormSection,
  Field,
  SelectField,
  TitleSection
} from "~/components/"
import {Location, Area} from "~/utils/ShelfEntities"
import {withTranslation} from "react-i18next"

class NewLocationView extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      areas: []
    }
  }

  componentDidMount() {
    Area.all()
      .then(areas => {
        this.setState({
          loading: false,
          areas
        })
      })
      .catch(err => {
        console.log("Error loading area data: " + err)
      })
  }

  render() {
    return this.state.loading ? (
      <p>{this.props.t("loading")}</p>
    ) : (
      <ApiForm
        for={Location}
        id={this.props.match.params.location_barcode}
        then="/warehouse"
        submitLabel={this.props.t("locations.detail.submit")}
        transformInitialState={state => ({
          ...state,
          area_id: state.area ? state.area.id : null
        })}
      >
        <TitleSection>
          <h3>
            {this.props.match.params.location_barcode
              ? this.props.t("locations.detail.titleEdit")
              : this.props.t("locations.detail.titleNew")}
          </h3>
        </TitleSection>
        <FormSection label={this.props.t("locations.detail.basic")}>
          <Field
            label={this.props.t("locations.detail.name")}
            type="Text"
            name="name"
          />
          <SelectField
            label={this.props.t("locations.detail.zone")}
            type="Text"
            name="area_id"
            options={this.state.areas}
          />
        </FormSection>
        <FormSection label={this.props.t("barcodeScanner")}>
          <Field label={this.props.t("barcode")} type="Text" name="barcode" />
        </FormSection>
      </ApiForm>
    )
  }
}

export default withTranslation()(NewLocationView)



// WEBPACK FOOTER //
// ./src/views/NewLocationView.js